import React, { Component } from 'react'
import { source } from 'react-aim';
import { Button, Popup } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import "./Toolbar.css";
const _ = require('lodash');

@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Template Action Icons")
})

class ToolbarDashboardDesigner extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    createDashboard = (e) => {
        dispatch.app.setCollapsedResourcePaneIndexTemp(null);
        const { history } = this.props;
        history.push(`/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_dc/create/selectTemplate`);
        // dispatch.templates.showResourecePane(null);
    }
    render() {
        return (
            <div className="toolBar header_buttons toolbatInputFile">

                <Button.Group size='mini' className="mar_Right_5" >
                    <Popup className="popupStyled" inverted trigger={<span onMouseEnter={() => dispatch.app.setHelpContext("Create Dashboard")}><Button icon='plus' className="clr-blue" onClick={this.createDashboard} /></span>}
                        content='Create Dashboard'
                    />
                </Button.Group>
            </div >
        )
    }
}

export default ToolbarDashboardDesigner

